import AppInsightsHelper, { MyObject } from './helper';

export const MYHKBN_CLICK_BUTTON_EVENT = 'MyHKBNClickButtonEvent';
export const MYHKBN_BACKGROUND_EVENT = 'MyHKBNBackgroundEvent';
export const MYHKBN_NAVIGATION_EVENT = 'MyHKBNNavigationEvent';
export const MYHKBN_CHANGE_TAB_EVENT = 'MyHKBNChangeTabEvent';
export const MYHKBN_LINKING_EVENT = 'MyHKBNLinkingEvent';
export const MYHKBN_REQUEST_EVENT = 'MyHKBNRequestEvent';
export const MYHKBN_RESPONSE_EVENT = 'MyHKBNResponseEvent';
export const MYHKBN_VIEW_DISPLAY_EVENT = 'MyHKBNViewDisplayEvent';
export const MYHKBN_ERROR_EVENT = 'MyHKBNErrorEvent';

export default class AppInsights {
    appInsightsHelper: AppInsightsHelper;

    constructor(scope: string) {
        this.appInsightsHelper = new AppInsightsHelper(scope);
    }
    /**
     * Track click action event
     * @param {object} eventName - Event name
     * @param {object} params - Customized information
     */
    trackClickEvent(buttonId: string, params: MyObject) {
        if (!params) {
            params = {};
        }

        let props = {
            ...params,
            buttonId,
        };

        // console.log(props);

        this.appInsightsHelper.trackEvent(MYHKBN_CLICK_BUTTON_EVENT, props);
    }

    /**
     * Track request action event
     * @param {object} params - Customized information
     */
    trackRequestEvent(params: MyObject) {
        this.appInsightsHelper.trackEvent(MYHKBN_REQUEST_EVENT, params);
    }

    /**
     * Track request action event
     * @param {object} params - Customized information
     */
    trackResponseEvent(params: MyObject) {
        this.appInsightsHelper.trackEvent(MYHKBN_RESPONSE_EVENT, params);
    }

    /**
     * Track change tab event
     * @param {object} params - Customized information
     */
    trackChangeTabEvent(params: MyObject) {
        console.log(params);
        this.appInsightsHelper.trackEvent(MYHKBN_CHANGE_TAB_EVENT, params);
    }

    /**
     * Track request action event
     * @param {object} params - Customized information
     */
    trackViewDisplayEvent(params: MyObject) {
        // console.log(params);
        this.appInsightsHelper.trackEvent(MYHKBN_VIEW_DISPLAY_EVENT, params);
    }

    /**
     * Track exception
     * @param {string} errorMessage - Exception message.
     */
    trackException(errorMessage: string) {
        this.appInsightsHelper.trackException(errorMessage);
    }
}

//exportconstAppInsightsLog=newAppInsights("MyHKBNWebbundle-common");
